<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>

    <data-time-query :query="query" style="margin-left:1em;float:left;" />

    <el-cascader
      v-model="query.siteDeviceIds"
      :options="siteTree"
      :props="{
        expandTrigger: 'hover',
        multiple: true,
        emitPath: false
      }"
      clearable
      :show-all-levels="false"
      collapse-tags
      size="small"
      style="margin-left:1em;"
    />

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      style="margin-left:1em;"
      @click="onSearchBtnClick"
    >查询</el-button>

    <el-button
      :disabled="dataList.length === 0"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onDownloadBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <data-table
        ref="dataTable"
        :key="dataTableKey"
        :columns="headerColumns"
        :data="dataList"
        :pagination="pagination"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>

import BaseSiteData from '../../BaseSiteData'
import LayoutContent from '../../../components/Layout/Content'
import manualOperatorTypes from '../01Manual/manualOperatorTypes'
import CSVDownloader from '../../../utils/CSVDownloader'
import DataWrapper from '../../../components/Data/DataWrapper'

const manualOperatorTypeMap = manualOperatorTypes.reduce((map, manualOperatorType) => {
  map[manualOperatorType.id] = manualOperatorType.name
  return map
}, {})

export default {
  name: 'DataAuditLog',
  routeInfo: {
    label: '审核日志',
    icon: 'fa fa-calendar'
  },
  extends: BaseSiteData,
  components: {DataWrapper, LayoutContent},
  data () {
    return {
      query: {
        siteDeviceIds: []
      },
      orgs: [],
      pagination: {
        no: 1,
        size: 24
      },
      dataTableKey: new Date().getTime()
    }
  },
  computed: {
    queryTimeStep: () => 2,
    headerColumns: () => [{
      id: 'dataTime',
      name: '数据时间',
      width: 170,
      align: 'left'
    }, {
      id: 'auditTime',
      name: '审核时间',
      width: 170,
      align: 'left'
    }, {
      id: 'auditOrgName',
      name: '审核组织',
      width: 200,
      align: 'left'
    }, {
      id: 'siteName',
      name: '站房',
      width: 150,
      align: 'left'
    }, {
      id: 'deviceName',
      name: '设备',
      width: 200,
      align: 'left'
    }, {
      id: 'factorName',
      name: '因子',
      width: 100,
      align: 'left'
    }, {
      id: 'value',
      name: '机审数值',
      width: 100,
      align: 'left'
    }, {
      id: 'auditResult',
      name: '审核结果',
      width: 200,
      align: 'left'
    }],
    profileSiteMap () {
      return this.profileSites.reduce((map, site) => {
        let {id} = site

        map[id] = {
          value: id,
          label: site.name,
          children: []
        }

        return map
      }, {})
    },
    profileSiteDeviceMap () {
      return this.profileSiteDevices.reduce((map, siteDevice) => {
        map[siteDevice.id] = siteDevice
        return map
      }, {})
    },
    siteTree () {
      let {profileSiteMap} = this

      this.profileSiteDevices.forEach(siteDevice => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return
        }

        site.children.push({
          value: siteDevice.id,
          siteId,
          label: siteDevice.name
        })
      })

      return Object.values(profileSiteMap)
    },
    orgMap () {
      return this.orgs.reduce((map, org) => {
        map[org.id] = org
        return map
      }, {})
    }
  },
  methods: {
    setSiteIds () {
      let {siteTree} = this

      if (siteTree.length > 0) {
        let {query: {siteDeviceIds}} = this

        if (siteDeviceIds.length === 0) {
          let site = siteTree.find(site => site.children.length > 0)

          if (!site) {
            return
          }

          siteDeviceIds.push(site.children[0].value)
        }

        this.afterSetSiteIds()
      }
    },
    getData () {
      this.changeLoadStatus(true)

      this.$api.Audit.getLog(this.currentQuery).then(this.renderData).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    renderData (dataList) {
      let {factorMap, profileSiteMap, profileSiteDeviceMap, orgMap} = this
      this.dataList = Object.freeze(dataList.map(data => ({
        dataTime: data.dataTime,
        auditTime: data.auditDate,
        auditOrgName: (orgMap[data.auditOrgId] || {}).name,
        siteName: (profileSiteMap[data.siteId] || {}).label,
        deviceName: (profileSiteDeviceMap[data.siteDeviceId] || {}).name,
        factorName: (factorMap[data.factorId] || {}).name,
        value: data.value,
        auditResult: `${manualOperatorTypeMap[data.auditFlag]}: ${data.auditComment}`
      })))

      this.dataTableKey = new Date().getTime()

      setTimeout(() => {
        this.$refs.dataTable.doLayout()
      }, 0)
    },
    onDownloadBtnClick () {
      let {currentQuery: {beginTime, endTime}, headerColumns, dataList} = this
      let filename = `审核日志${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}`
      CSVDownloader([headerColumns.map(column => column.name)].concat(dataList.map(data => headerColumns.map(column => data[column.id]))), filename)
    }
  },
  created () {
    this.$api.Org.getList().then(orgs => {
      this.orgs = Object.freeze(orgs)
    }).catch(console.error)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/08Log/index.vue